module.exports = __webpack_public_path__ + "static/media/image_library.304d33ee.png";